import { render, staticRenderFns } from "./SpaceSettings.vue?vue&type=template&id=277a5bea"
import script from "./SpaceSettings.vue?vue&type=script&lang=js"
export * from "./SpaceSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports